import {
    ADD_REFERRAL,
    UPDATE_REFERRAL,
    DELETE_REFERRAL,
    GET_REFERRALS,
    GET_REFERRAL,
    REFERRAL_ERROR,
} from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";
import { setAlert } from "../alert";

export const getReferral = (id) => async (dispatch) => {
    try {
        const res = await customAxios.get(`/api/admin/referrals/${id}`);
        dispatch({
            type: GET_REFERRAL,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: REFERRAL_ERROR,
            payload: { msg: err.response, status: err.response.status },
        });
    }
};

export const getReferrals = () => async (dispatch) => {
    try {
        const res = await customAxios.get(`/api/admin/referrals`);
        dispatch({
            type: GET_REFERRALS,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: REFERRAL_ERROR,
            payload: { msg: err.response, status: err.response?.status },
        });
    }
};

export const getLinkReferral = async (id) => {
    try {
        const res = await customAxios.get(`/api/admin/referrals/${id}/link`);

        return res;
    } catch (err) {
        return err;
    }
};

export const addReferral = (requestBody) => async (dispatch) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const res = await customAxios.post(`/api/admin/referrals`, requestBody, config);

        dispatch({
            type: ADD_REFERRAL,
            payload: res.data.data,
        });

        dispatch(setAlert("Referral Successfully Added!"));
    } catch (err) {
        dispatch({
            type: REFERRAL_ERROR,
            payload: { msg: err.response, status: err.response.status },
        });
    }
};

export const updateReferral = (requestBody, id) => async (dispatch) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const res = await customAxios.put(`/api/admin/referrals/${id}`, requestBody, config);

        dispatch({
            type: UPDATE_REFERRAL,
            payload: res.data.data,
        });

        dispatch(setAlert("Referral Successfully Updated!"));
    } catch (err) {
        dispatch({
            type: REFERRAL_ERROR,
            payload: { msg: err.response, status: err.response.status },
        });
    }
};

export const deleteReferral = (id) => async (dispatch) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const res = await customAxios.delete(`/api/admin/referrals/${id}`, config);

        dispatch({
            type: DELETE_REFERRAL,
            payload: res.data.data,
        });

        dispatch(setAlert("Referral Successfully Updated!"));
    } catch (err) {
        dispatch({
            type: REFERRAL_ERROR,
            payload: { msg: err.response, status: err.response.status },
        });
    }
};